import { Box, Flex, PrimaryButton } from "@nulogy/components";
import IndexTable from "components/common/IndexTable";
import UnstyledLink from "components/common/UnstyledLink";
import { formatDateTime } from "components/helpers/format";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import paths from "config/routePaths";
import React from "react";

const COLUMNS = [
  { cellRenderer: companyCellRenderer, dataKey: "name", label: "Company name", numeric: true },
  { cellFormatter: formatTime, dataKey: "createdAt", label: "Created" },
  { cellFormatter: formatTime, dataKey: "updatedAt", label: "Last updated" },
  { dataKey: "id", label: "UUID" },
];

function formatTime({ cellData }) {
  return formatDateTime(cellData);
}

function companyCellRenderer({ row }) {
  return <UnstyledLink href={paths.companyEdit(row.id)}>{row.name}</UnstyledLink>;
}

export default function CompanyIndexView({ companies }) {
  return (
    <PageWithBreadcrumbs title="Companies">
      <Flex className="spec-companies-index-page">
        <Box>
          <PrimaryButton asLink href={paths.companyNew} marginTop="x1" size="small" type="button">
            Create company
          </PrimaryButton>
        </Box>
      </Flex>
      <IndexTable columns={COLUMNS} initialSortColumn="name" keyField="id" rows={companies} />
    </PageWithBreadcrumbs>
  );
}
